import type { Epic, Incident, Issue, Task } from '@/features/project-board/types';

/**
 * 항목을 가리키는 키.
 *
 * 하네스 저장소가 여러 개면 slug·이슈 id·task id가 저장소마다 겹친다(둘 다 `001`부터 쓴다).
 * 그래서 화면에서 항목을 세거나(React key) 서로 잇을 때는 **저장소까지 함께** 봐야 한다 —
 * slug만 쓰면 이름이 같은 다른 하네스의 항목이 하나로 접힌다.
 */
export class ItemKey {
  static epic(epic: Pick<Epic, 'source' | 'slug'>): string {
    return `${epic.source}#${epic.slug}`;
  }

  static issue(issue: Pick<Issue, 'source' | 'id'>): string {
    return `${issue.source}#${issue.id}`;
  }

  static incident(incident: Pick<Incident, 'source' | 'id'>): string {
    return `${incident.source}#${incident.id}`;
  }
}

/** 에픽과 task의 소속. 같은 저장소 안에서만 잇는다. */
export class EpicMembership {
  /** task가 속한 에픽. 같은 저장소 안에서만 찾는다. */
  static epicOf(epics: readonly Epic[], task: Task): Epic | undefined {
    return epics.find((epic) => epic.source === task.source && epic.slug === task.epicSlug);
  }

  /** 에픽에 속한 task. 같은 저장소 안에서만 찾는다. */
  static tasksOf(tasks: readonly Task[], epic: Pick<Epic, 'source' | 'slug'>): Task[] {
    return tasks.filter((task) => task.source === epic.source && task.epicSlug === epic.slug);
  }
}
